import React, { FC, useMemo } from "react";
import { Button, SxProps } from "@mui/material";
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import { useAtomValue } from "jotai";
import { scoringSelectedPeriodAtom } from "../../stores/jotai/scoring/selectedPeriodIndex";
import { cohortPeriodsAtom } from "../../stores/jotai/cohortPeriods";
import { baseAtom } from "../../stores/jotai/base";
import { cohortCommentsAtom } from "../../stores/jotai/comments/cohortComments";

interface IScoringPresentationLinkProps {
    sx?: SxProps;
}

const PRESENTATION_LINK_BUTTON_STYLES: SxProps = {
    height: "28px",
    padding: "6px 12px",
};

const ScoringPresentationLink: FC<IScoringPresentationLinkProps> = (props) => {
    const { sx } = props;
    const base = useAtomValue(baseAtom);
    const comments = useAtomValue(cohortCommentsAtom);
    const periods = useAtomValue(cohortPeriodsAtom);
    const selectedPeriodIndex = useAtomValue(scoringSelectedPeriodAtom);

    const presentationLink = useMemo(() => {
        const selectedPeriodID = periods[selectedPeriodIndex]?.groupPeriodID;
        const teamID = base?.team?.groupID;
        const presentationComment = comments?.find(
            (comment) =>
                comment.groupID === teamID &&
                comment.slug == "presentation-link" &&
                comment.period === selectedPeriodID
        );

        if (presentationComment?.content) {
            return `https://${presentationComment.content.replace("https://", "")}`;
        }

        return null;
    }, [comments, periods, selectedPeriodIndex]);

    return (
        <Button
            variant="contained"
            sx={{ ...PRESENTATION_LINK_BUTTON_STYLES, ...sx }}
            startIcon={!!presentationLink && <OpenInNewOutlinedIcon />}
            href={presentationLink}
            target="_blank"
            disabled={!presentationLink}
        >
            {presentationLink ? "View Presentation" : "Presentation N/A"}
        </Button>
    );
};

export default ScoringPresentationLink;


